// extracted by mini-css-extract-plugin
export default {"iconContainer":"SystemIcons_iconContainer__mEz38"};